import * as React from 'react';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Unstable_Grid2';

import { getDetailsReviews } from 'application/redux/selectors';
import { Page } from 'components/Layout';
import { LabeledData } from 'components/Input';
import { formatDollar } from 'helpers/formatters';

interface Props {
    areTaxesComplete?: boolean;
    fillHeight?: boolean;
}

const AdjustmentReviewPage: React.FunctionComponent<Props> = (props) => {
    const { areTaxesComplete, fillHeight } = props;

    // Global State
    const uwReviews = useSelector(getDetailsReviews);

    // Local State
    const uwReview = uwReviews[0] || {};

    return (
        <Page title="Other Change Review" fillHeight={fillHeight}>
            <Grid container direction="row" spacing={8}>
                <Grid md={areTaxesComplete ? 6 : 7} xs={12}>
                    <LabeledData title="Premium" value={uwReview.premium ? formatDollar(uwReview.premium) : '--'} />
                </Grid>
                {areTaxesComplete && (
                    <>
                        <Grid md={6} xs={12}>
                            <LabeledData title="Home State" value={uwReview.homeState} />
                        </Grid>
                        <Grid md={6} xs={12}>
                            <LabeledData title="State Tax" value={formatDollar(uwReview.slaTax)} />
                        </Grid>
                        <Grid md={6} xs={12}>
                            <LabeledData title="Stamping Fee" value={formatDollar(uwReview.slaFee)} />
                        </Grid>
                    </>
                )}
                <Grid md={6} xs={12}>
                    <LabeledData
                        title="Policy Fee"
                        value={uwReview.policyFee ? formatDollar(uwReview.policyFee) : '--'}
                    />
                </Grid>
                <Grid md={6} xs={12}>
                    <LabeledData
                        title="Professional Fee"
                        value={uwReview.professionalFee ? formatDollar(uwReview.professionalFee) : '--'}
                    />
                </Grid>
                <Grid xs={12}>
                    <LabeledData title="Narrative" value={uwReview.narrative} />
                </Grid>
            </Grid>
        </Page>
    );
};

export default AdjustmentReviewPage;
